import React from 'react';
import {Parallax, Background} from 'react-parallax';
import CountdownTimer from 'react-awesome-countdowntimer';
import moment from 'moment';
import '../Home.css'
import BackgroundSlideshow from '../../../components/slideshow/BackgroundSlideshow';
import image1 from '../../../assets/images/1.jpg';
// import image2 from '../../../assets/images/2.jpg';
import image3 from '../../../assets/images/3.jpg';
import image4 from '../../../assets/images/4.jpg';
import image5 from '../../../assets/images/5.jpg';
import image6 from '../../../assets/images/6.jpg';
import logo from '../../../assets/images/logo.svg'
import groovy from '../../../assets/images/groovy.svg'
import grails from '../../../assets/images/grails.svg'
import geb from '../../../assets/images/geb.svg'
import spock from '../../../assets/images/spock.png'
import java from '../../../assets/images/java.svg'
import quarkus from '../../../assets/images/quarkus.svg'
import helidon from '../../../assets/images/helidon.svg'
import micronaut from '../../../assets/images/micronaut.svg'
import gradle from '../../../assets/images/gradle.svg'
import jenkins from '../../../assets/images/jenkins.svg'
import boot from '../../../assets/images/spring-boot.svg'
import {Col, Grid, Row} from "react-bootstrap";

const Event = () => (<div className="event">
  <Parallax
    strength={-240}
    blur={{min: -10, max: 20}}
  >
    <Background>
      <div style={{position: 'relative', width: '100%', height: 1050}}>
        <BackgroundSlideshow style={{height: '1050', top: 95}} imageDuration={10}
                             images={[image1, image3, image4, image5, image6]}/>
      </div>

    </Background>
    <div className="conference">
      <div className="conference-header">
        <Grid>
          <Row>
            <Col xs={12}>
              <div class="canceled">
                <h1>Cancelled!</h1>
                <p>Due to the current COVID-19 situation we have decided to cancel GR8Conf & JDK IO 2020.</p>
                <p>We will return in 2021, hopefully either May 26th-28th or June 2nd-4th.</p>
                <p>Sorry to disappoint you all!</p>
                <p>Best regards</p><p>Søren Berg Glasius</p><p>and the entire GR8Conf & JDK IO Crew</p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xsHidden smHidden mdHidden lg={3} className="tech-logos">
              <div>
                <img src={groovy} alt="Groovy"/>
              </div>
              <div>
                <img src={grails} alt="Grails"/>
              </div>
              <div>
                <img src={spock} alt="Spock Framework"/>
              </div>
              <div>
                <img src={geb} alt="GEB"/>
              </div>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Row>
                <Col xsHidden smHidden mdHidden lg={4} className="tech-logos">
                  <div>
                    <img src={micronaut} alt="Micronaut"/>
                  </div>

                </Col>
                <Col xsHidden smHidden mdHidden lg={4} className="tech-logos">
                  <div>
                    <img src={quarkus} alt="Quarkus"/>
                  </div>

                </Col>
                <Col xsHidden smHidden mdHidden lg={4} className="tech-logos">
                  <div>
                    <img src={helidon} alt="Helidon"/>
                  </div>

                </Col>
              </Row>
              <div className="conference-info">
                <div className="name">
                  <img src={logo} style={{height: 300}} alt="GR8Conf & JDK IO 2020"/>
                </div>
                <div className="dates">
                  June 2nd - 4th
                </div>
                <div className="where">
                  <strong>Copenhagen</strong>, Denmark
                </div>
                <div className="tag-line">
                  <p><strong>All Things Groovy and Java</strong>
                  </p>
                </div>
              </div>
            </Col>
            <Col xsHidden smHidden mdHidden lg={3} className="tech-logos">
              <div>
                <img src={java} alt="Java"/>
              </div>
              <div>
                <img src={boot} alt="Spring Boot"/>
              </div>
              <div>
                <img src={gradle} alt="Gradle"/>
              </div>
              <div>
                <img src={jenkins} alt="Jenkins CI"/>
              </div>
            </Col>

          </Row>
        </Grid>
      </div>
      {/*<div className="countdown">*/}
      {/*  <CountdownTimer endDate={moment('02/06/2020 08:00:00', 'DD/MM/YYYY hh:mm:ss')}/>*/}
      {/*</div>*/}
    </div>
  </Parallax>
</div>);

export default Event;



// WEBPACK FOOTER //
// ./src/pages/home/fragments/Event.js